/**
 * @desc 盘点单审核列表
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.inventoryMaster.listForApproval.Params, options?: any) {
  return updateResponse(
    http(URL + `/inventoryMaster/listForApproval`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
